import $ from 'jquery'
import * as FilePond from 'filepond'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import fr_fr from 'filepond/locale/fr-fr.js';
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import { Alert } from '../functions'

FilePond.setOptions(fr_fr);
FilePond.registerPlugin(FilePondPluginFileValidateType);

const object = vnObject

const pond = FilePond.create(document.querySelector('.filepond-cv'), {
    acceptedFileTypes: [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'image/jpeg',
        'image/png',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template'
    ],
    fileValidateTypeLabelExpectedTypesMap: {
        'application/pdf': '.pdf',
        'application/msword': '.doc',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
        'image/jpeg': '.jpg, .jpeg',
        'image/png': '.png',
        'application/vnd.oasis.opendocument.text': '.odt',
        'application/vnd.oasis.opendocument.text-template': '.fodt, .ppg'
    },
    fileValidateTypeLabelExpectedTypes: 'Expects {allButLastType} or {lastType}',
});

const createCvForm = $('.js-pdf-create-cv-form')

if (createCvForm.length) {
    createCvForm.parsley().on('form:success', function () {
        createCvForm.attr('data-success', 'true')
    })

    createCvForm.parsley().on('form:error', function () {
        createCvForm.attr('data-success', 'false')
    })

    createCvForm.on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()

        const formData = new FormData(createCvForm[0])
        formData.append('action', 'vn_create_cv')
        formData.append('nonce', object.nonce)

        const $form = $(this)
        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            data: formData,
            beforeSend: () => {
                $form.addClass('sending')
                Alert('warning', object.formWait, false)
            },
            processData: false,
            contentType: false,
            success: (res) => {
                $form.removeClass('sending')

                Alert(res.success, res.data.message)
            },
        })
    })
}

const uploadCvForm = $('.js-upload-cv-form')

if (uploadCvForm.length) {

    uploadCvForm.on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()

        const formData = new FormData(uploadCvForm[0])
        formData.append('action', 'vn_upload_cv')
        formData.append('nonce', object.nonce)
        var pondFiles = pond.getFiles();
        if ( pondFiles[0] ) {
            formData.append('cv', pondFiles[0].file);
        }

        const $form = $(this)
        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            data: formData,
            beforeSend: () => {
                $form.addClass('sending')
                Alert('warning', object.formWait, false)
            },
            processData: false,
            contentType: false,
            success: (res) => {
                $form.removeClass('sending')

                Alert(res.success, res.data.message)
            },
        })
    })
}



$('.pt-my-cv__section--title.js-section-title').click(function(){
    var parent = $(this).parent().parent()
    if($(window).width() < 768) {
        if (parent.hasClass('pt-my-cv__section--open')) {
            parent.find('.js-section-texts').slideUp()
            parent.removeClass('pt-my-cv__section--open')
        } else {
            $('.pt-my-cv__section--open').each(function() {
                $(this).find('.js-section-texts').slideUp()
                $(this).removeClass('pt-my-cv__section--open')
            });
            parent.find('.js-section-texts').slideDown()
            parent.addClass('pt-my-cv__section--open')
        }
    }
})
